import api from "./api";

const banners = `mocks${import.meta.env.VITE_BASE_PATH}banners.atendimento2.json`
var jsonFinal = "" 
class BannerAtendimentoService2 {
  async get() {
    if(!jsonFinal){
      const resp = await fetch(banners)
      jsonFinal = await resp.json()
    }
    return jsonFinal
  }
}

export default new BannerAtendimentoService2();
